import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./auth.slice";
import { userSystemReducer } from "./userSystem.slice";
import { roleReducer } from "./roles.slice";
import { shippingReducer } from "./shipping.slice";
import { userCustomerReducer } from "./userCustomer.slice";
import { addressReducer } from "./address.slice";
import { paymentReducer } from "./payment.slice";
import { fileManagerReducer } from "./fileManager.slice";
import { productReducer } from "./product.slice";
import { systemReducer } from "./system.slice";
import { blogReducer } from "./blog.slice";
import { orderReducer } from "./order.slice";

export * from "./auth.slice";
export * from "./userSystem.slice";
export * from "./roles.slice";
export * from "./shipping.slice";
export * from "./userCustomer.slice";
export * from "./address.slice";
export * from "./payment.slice";
export * from "./fileManager.slice";
export * from "./product.slice";
export * from "./system.slice";
export * from "./blog.slice";
export * from "./order.slice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    userSystem: userSystemReducer,
    role: roleReducer,
    shipping: shippingReducer,
    userCustomer: userCustomerReducer,
    address: addressReducer,
    payment: paymentReducer,
    fileManager: fileManagerReducer,
    product: productReducer,
    system : systemReducer,
    blog : blogReducer,
    order : orderReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
